// import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllInsurancesResponseModel, GetInsuranceResponseModel, InsuranceDto } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../countries/dto/user-request-dto';
import { InsuranceTypeRequest } from './dto/insurance-type.request';
import { InsuranceRequest } from './dto/insurance.request';
import { InsuranceService } from './insurance.service';

@ApiTags('Insurance')
@Controller('insurance')
export class InsuranceController {

    constructor(
        private insuranceService: InsuranceService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}

    @Post('/getAllInsurances')
    async getAllInsurances(@Body() req?:UserRequestDto): Promise<AllInsurancesResponseModel> {
        try {
            return await this.insuranceService.getAllInsurances(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllInsurancesResponseModel, error)
        }
    }
    @Post('/getInsuranceByType')
    async getInsuranceByType(@Body() req: InsuranceTypeRequest): Promise<AllInsurancesResponseModel> {
        try {
            return await this.insuranceService.getInsuranceByType(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllInsurancesResponseModel, error)
        }
    }
    @Post('/createInsurance')
    async createInsurance(@Body() req: InsuranceDto,isUpdate:boolean=false,@Req() request:Request): Promise<GetInsuranceResponseModel> {
        try {
            return await this.insuranceService.createInsurance(req,false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetInsuranceResponseModel, error)
        }
    }
    @Post('/updateInsurance')
    async updateInsurance(@Body() insuranceDto: InsuranceDto,@Req() request:Request): Promise<GetInsuranceResponseModel> {
        try {
        return await this.insuranceService.createInsurance(insuranceDto, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetInsuranceResponseModel, error)
        }
    }
    @Post('/activateOrDeactivateInsurance')
    async activateOrDeactivateInsurance(@Body() insuranceReq: InsuranceRequest): Promise<GetInsuranceResponseModel> {
        console.log(insuranceReq);
        try {
            return await this.insuranceService.activateOrDeactivateInsurance(insuranceReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(GetInsuranceResponseModel, err);
        }
    }

}
